<ng-container *ngIf="product?.hopOnHopOff">
  <h2 class="h2" *ngIf="_mainStops?.length>0" text-color="gray-dark">{{'MAIN_STOPS' | translate}}</h2>
  <div class="stop-container" *ngIf="_mainStops?.length>0">
    <div class="width_arrow" *ngIf="startIndex != -1">
      <i (click)="previousItem()" class="left-arrow material-icons notranslate">play_arrow</i>
    </div>
    <ng-container *ngFor="let stop of _mainStops; let i = index" class="stop-card">
      <div *ngIf="(i > startIndex) && (i < endIndex)" class="stop-card main-stops-animation">
        <img [lazyLoad]="getUrl(stop?.imageURL)" alt="{{product.name}}/{{stop.name}}/{{stop.number}}" (swipeleft)="swipe($event.type)" (swiperight)="swipe($event.type)" />
        <div class="stop-title">
          <div class="stop-number" [ngStyle]="{'background-color':stop?.color}">
            {{stop.number ? stop.number : stop.placeOrder}}
          </div>
          <div class="stop-text">
            <div class="stop-name">
              {{stop.name}}
            </div>
            <div class="stop-route">
              {{stop.routeName}}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="width_arrow" *ngIf="endIndex != _mainStops?.length">
      <i (click)="nextItem()" class="right-arrow material-icons notranslate">play_arrow</i>
    </div>
  </div>
</ng-container>